import React from 'react'

const Experience: React.FC = () => {
  const experiences = [
    {
      id: 1,
      company: 'Proflemsa',
      position: 'Ingeniero En Soporte',
      period: '2024 - Actualidad',
      location: 'Mérida Yucatán, México',
      description: 'Implementación, soporte en soluciones de software y automatización de inventarios activos, soporte administrativo y ERP.',
      achievements: [
    "Reduje el tiempo de despliegue en un 70% mediante la implementación de pipelines CI/CD con Jenkins y Terraform",
    "Diseñé e implementé una arquitectura de microservicios escalable que soporta más de 1000 usuarios activos en chatbots de WhatsApp",
    "Lideré la migración exitosa de una aplicación monolítica a microservicios con cero downtime, mejorando la disponibilidad y mantenibilidad del sistema"
  ],
    technologies: [ "WhatsApp Business API","Kubernetes", "Docker", "AWS", "Terraform", "Node.js", "API REST"]
    },
  {
      id: 2,
      company: 'Anzencode (Proyecto)',
      position: 'Ingeniero de Software',
      period: '2020 - 2024',
      location: 'México',
      description: 'Desarrollo e implementación de soluciones de automatización y chatbots para WhatsApp, utilizando arquitecturas cloud-native basadas en microservicios. Diseño e integración de APIs REST y contenedores Docker para entornos escalables en la nube.',
      achievements: [
    "Reduje el tiempo de despliegue en un 70% mediante la implementación de pipelines CI/CD con Jenkins y Terraform",
    "Diseñé e implementé una arquitectura de microservicios escalable que soporta más de 1000 usuarios activos en chatbots de WhatsApp",
    "Lideré la migración exitosa de una aplicación monolítica a microservicios con cero downtime, mejorando la disponibilidad y mantenibilidad del sistema"
  ],
    technologies: [ "WhatsApp Business API","Kubernetes", "Docker", "AWS", "Terraform", "Node.js", "API REST"]
    }
  ]

  return (
    <section id="experiencia" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="section-title">Experiencia Profesional</h2>
        <div className="max-w-4xl mx-auto">
          {experiences.map((experience) => (
            <div key={experience.id} className="bg-white rounded-lg shadow-md p-8 mb-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800">{experience.position}</h3>
                  <h4 className="text-xl text-blue-600 font-semibold">{experience.company}</h4>
                </div>
                <div className="text-right mt-2 md:mt-0">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    {experience.period}
                  </span>
                  <p className="text-gray-600 mt-1">{experience.location}</p>
                </div>
              </div>
              
              <p className="text-gray-600 mb-6 leading-relaxed">{experience.description}</p>
              
              <div className="mb-6">
                <h4 className="font-semibold text-gray-800 mb-3">Logros Clave:</h4>
                <ul className="space-y-2">
                  {experience.achievements.map((achievement, index) => (
                    <li key={index} className="flex items-start">
                      <div className="w-2 h-2 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <span className="text-gray-600">{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-800 mb-3">Tecnologías Utilizadas:</h4>
                <div className="flex flex-wrap gap-2">
                  {experience.technologies.map((tech, index) => (
                    <span
                      key={index}
                      className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium hover:bg-gray-200 transition-colors duration-200"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Experience